import { Injectable, Injector  } from '@angular/core';
import { Router } from '@angular/router';
import {UtilsService} from './utils.service';
import {UserService} from './user.service';
import { Store } from '@ngrx/store';
import * as fromStore from '../store';
import {filter} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class StartupService {
// Check login status.
  constructor(
    private injector: Injector,
    private utils: UtilsService,
    private store: Store<fromStore.State>
  ) { }
  load(): Promise<any> {
    return new Promise((resolve, reject) => {
      if (!this.utils.isTokenExpired()) {
        // First time get into the cloud page, get login info status from the local storage.
        this.store.dispatch(new fromStore.GetUserAction());
        return this.store.select(fromStore.getIsLogin)
          .pipe(
            filter(status => status)
          )
          .subscribe(res => {
            if (res) {
              setInterval(() => {
                this.checkStatus();
              }, 1000 * 60 * 5); // check current status every 5 min
            }
            resolve(res);
          }, err => {
            console.log(err);
            reject(err);
          });
      } else {
        console.log('expired');
        resolve('no token or token expired');
      }
    });
  }
  checkStatus() {
    if (this.utils.isTokenExpired()) {   // if token expired or not exist
      this.store.dispatch(new fromStore.LogoutAction());
      const router = this.injector.get(Router);
      router.navigate(['/login']);
    }
  }
}
